import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import * as React from 'react';

import BackspaceIcon from '@material-ui/icons/Backspace';
import { DeltaXMLColors, DeltaJSONColors } from '../styling/DeltaColors';

export interface DialogButtonProps {
    onClearInputs: () => void;
}

function DialogButton(props: DialogButtonProps) {
    const { onClearInputs } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleYes = () => {
        handleClose();
        onClearInputs();
    };
    const handleClose = () => {
      setOpen(false);
    }

    return (
        <>
        <Button
            variant="contained"
            color="primary"
            endIcon={<BackspaceIcon />}
            onClick={handleClickOpen}>     
            Clear Files
        </Button>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" style={{backgroundColor: DeltaXMLColors.OXFORD_BLUE, color: DeltaXMLColors.CELERY}}>{"Clear Input Files"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    All input files will be cleared. Are you sure you wish to proceed?
          </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleYes} color="primary" variant="contained">
                    Yes
          </Button>
                <Button onClick={handleClose} color="primary" variant="contained">
                    No
          </Button>
            </DialogActions>
        </Dialog>
        </>
    )

}


export default (DialogButton);